module.exports = __webpack_public_path__ + "img/SOLICITUD PERSONA FISICA.729a33b7.jpg";